import React, { useState, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import {
  H2,
  P,
  Icon,
  Modal,
  ModalHeader,
  ModalBody,
  Grid,
  Header,
  FlexRow,
  BaseCol
} from '@contently/toolkit';
import { validateStoredRegion, US_AND_CANADA } from '../value/utils';
import FilterWrapper from '../value/filter_wrapper';
import TableWrapper from './table_wrapper';

const StoryLevelWrapper = ({ appData }) => {
  const { story_level_table: tableInfo, pub_traffic_value_avg: trafficValAvg } = JSON.parse(
    appData
  );

  const storedRegion = localStorage.getItem('contentValueRegion');
  validateStoredRegion(storedRegion);
  const [filterState, setFilterState] = useState(storedRegion || US_AND_CANADA);
  const [modal, setModal] = useState(false);

  return (
    <Fragment>
      <Modal isOpen={modal} onClose={() => setModal(false)}>
        <ModalHeader>
          <H2>Story Content Value</H2>
        </ModalHeader>
        <ModalBody>
          <P>
            This page tracks the Content Value of individual stories. To learn more about the
            metrics that appear on this page, visit{' '}
            <a href="https://help.contently.com/en/articles/4273934-understanding-and-improving-your-content-value-dashboard">
              this article
            </a>{' '}
            in Contently&apos;s help center.
          </P>
        </ModalBody>
      </Modal>
      <Grid>
        <FlexRow>
          <BaseCol md={10}>
            <Header>
              <H2>
                Story Content Value
                <Icon type="question-circle" onClick={() => setModal(true)} />
              </H2>
            </Header>
          </BaseCol>
          <FilterWrapper filterState={filterState} setFilterState={setFilterState} />
        </FlexRow>
        <FlexRow>
          <BaseCol>
            <TableWrapper
              region={filterState}
              tableInfo={tableInfo}
              trafficValAvg={trafficValAvg}
              header="Traffic Value by Content Pillar"
            />
          </BaseCol>
        </FlexRow>
      </Grid>
    </Fragment>
  );
};

export default StoryLevelWrapper;

StoryLevelWrapper.propTypes = {
  appData: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/story_level_wrapper.jsx